(function () {
  const THUMB_LIST = '.product__media-wrapper slider-component.thumbnail-slider ul.thumbnail-list.slider';

  function bindTrack(track) {
    if (track.dataset.thumbDragInit) return;
    track.dataset.thumbDragInit = '1';

    let isDown = false;
    let moved = false;
    let originX = 0;
    let originScroll = 0;

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      track.style.removeProperty('cursor');
      track.style.removeProperty('user-select');
      window.setTimeout(() => {
        moved = false;
      }, 0);
    };

    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      moved = false;
      originX = e.pageX;
      originScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.userSelect = 'none';
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const dx = e.pageX - originX;
      if (Math.abs(dx) > 4) moved = true;
      if (moved) e.preventDefault();
      track.scrollLeft = originScroll - dx;
    });

    track.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(THUMB_LIST).forEach(bindTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelectorAll) init(event.target);
  });
})();
